import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
export function KidsTaekwondoWhatYouLearn() {
  return <section className="py-24 bg-off-white" data-id="element-2259">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2260">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-2261">
          <div data-id="element-2262">
            <h2 className="text-4xl md:text-5xl text-ink mb-8" data-id="element-2263">
              What You'll Learn
            </h2>
            <ul className="flex flex-col gap-4" data-id="element-2264">
              {['Respect for parents, teachers, and peers', 'Goal setting through the belt progression system', 'Physical fitness, balance, and coordination', 'Self-defense fundamentals and stranger awareness', 'How to handle failure and bounce back stronger', 'Olympic-style Taekwondo techniques'].map((item, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-gray-warm" data-id="element-2265">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-2266" />
                  <span data-id="element-2267">{item}</span>
                </li>)}
            </ul>
            <div className="mt-10" data-id="element-2268">
              <Link to="/SignMeUp" className="btn-primary" data-id="element-2269">
                Start With a Trial Class
              </Link>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-[400px]" data-id="element-2270">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.stormtaekwondo.com/uploaded/images/Redesigne%202024/Discover%20the%20Perfect%20Program%20for%20Your%20Mini%20Trooper.png" alt="Training at Storm Taekwondo" className="block w-full h-full object-cover" data-id="element-2271" />
          </div>
        </div>
      </div>
    </section>;
}